import { render, staticRenderFns } from "./fakeEfficiencyChart.vue?vue&type=template&id=3cf51868&scoped=true"
import script from "./fakeEfficiencyChart.vue?vue&type=script&lang=js"
export * from "./fakeEfficiencyChart.vue?vue&type=script&lang=js"
import style0 from "./fakeEfficiencyChart.vue?vue&type=style&index=0&id=3cf51868&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf51868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf51868')) {
      api.createRecord('3cf51868', component.options)
    } else {
      api.reload('3cf51868', component.options)
    }
    module.hot.accept("./fakeEfficiencyChart.vue?vue&type=template&id=3cf51868&scoped=true", function () {
      api.rerender('3cf51868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/distributionDataMonitoring/com/fakeEfficiencyChart.vue"
export default component.exports